var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "invite-rules-root",
      class: { "ar-style": _vm.$i18n.locale === "ar" },
    },
    [
      _c(
        "div",
        {
          staticClass: "custom-nav-block",
          style: `paddingTop:${_vm.barHeight}px`,
        },
        [
          _c("van-nav-bar", {
            attrs: { title: "", "left-arrow": "" },
            on: { "click-left": _vm.handleBack },
            scopedSlots: _vm._u([
              {
                key: "left",
                fn: function () {
                  return [
                    _c("img", {
                      staticClass: "left-nav",
                      attrs: { src: require("./images/arrow-l.png"), alt: "" },
                    }),
                    _c("span", { staticClass: "tit-left" }, [
                      _vm._v(_vm._s(_vm.$t("lang.call.tit1"))),
                    ]),
                  ]
                },
                proxy: true,
              },
            ]),
          }),
        ],
        1
      ),
      _c("div", { staticClass: "rules-content" }, [
        _c(
          "div",
          {
            staticClass: "rules-block",
            staticStyle: { "letter-spacing": "-0.5px" },
          },
          [
            _c("p", { staticClass: "rules-title right-read" }, [
              _vm._v(_vm._s(_vm.$t("lang.newInvite.k016"))),
            ]),
            _c("p", { staticClass: "rules-row right-read" }, [
              _vm._v(_vm._s(_vm.$t("lang.newInvite.k017"))),
            ]),
            _c("p", { staticClass: "rules-row right-read" }, [
              _vm._v(_vm._s(_vm.$t("lang.newInvite.k018"))),
            ]),
            _c("p", { staticClass: "rules-row right-read" }, [
              _vm._v(_vm._s(_vm.$t("lang.newInvite.k019"))),
            ]),
            _c("p", { staticClass: "rules-row right-read" }, [
              _vm._v(_vm._s(_vm.$t("lang.newInvite.k020"))),
            ]),
            _vm.baseInfo && _vm.baseInfo.videoLimitDay
              ? _c("MyPLabel", {
                  staticClass: "rules-row",
                  attrs: {
                    str: _vm.$t("lang.newInvite.k035"),
                    numsOption: [{ value: _vm.baseInfo.videoLimitDay }],
                  },
                })
              : _vm._e(),
          ],
          1
        ),
        _c(
          "div",
          {
            staticClass: "rules-block",
            staticStyle: { "letter-spacing": "-1px" },
          },
          [
            _c("p", { staticClass: "rules-title right-read" }, [
              _vm._v(_vm._s(_vm.$t("lang.inRule.inviteBonus"))),
            ]),
            _vm.baseInfo && _vm.baseInfo.videoTimes <= 1
              ? _c("MyPLabel", {
                  staticClass: "rules-row right-read",
                  attrs: {
                    str: _vm.$t("lang.newInvite.k021"),
                    numsOption: [
                      { value: _vm.baseInfo.videoTimes || "?" },
                      { value: _vm.baseInfo.videoMinSeconds || "?" },
                      { value: _vm.baseInfo.videoLimitDay || "?" },
                      {
                        value: _vm.baseInfo.rewardBeans || "?",
                        style: "color:#a338fc",
                      },
                    ],
                  },
                })
              : _vm._e(),
            _vm.baseInfo && _vm.baseInfo.videoTimes > 1
              ? _c("MyPLabel", {
                  staticClass: "rules-row right-read",
                  attrs: {
                    str: _vm.$t("lang.newInvite.k021_1"),
                    numsOption: [
                      { value: _vm.baseInfo.videoTimes || "?" },
                      { value: _vm.baseInfo.videoMinSeconds || "?" },
                      { value: _vm.baseInfo.videoLimitDay || "?" },
                      {
                        value: _vm.baseInfo.rewardBeans || "?",
                        style: "color:#a338fc",
                      },
                    ],
                  },
                })
              : _vm._e(),
            _c("p", { staticClass: "rules-row right-read" }, [
              _vm._v(_vm._s(_vm.$t("lang.newInvite.k022"))),
            ]),
            _c("p", { staticClass: "rules-row right-read" }, [
              _vm._v(_vm._s(_vm.$t("lang.newInvite.k023"))),
            ]),
            _c(
              "div",
              { staticClass: "zone-block" },
              [
                _vm._l(_vm.zoneList1, function (item, index) {
                  return [
                    (!_vm.zone1ShowMore && index < 6) || _vm.zone1ShowMore
                      ? _c(
                          "div",
                          {
                            key: item.locationCode,
                            staticClass: "zone-item right-align",
                          },
                          [
                            _c("div", [
                              _c("img", {
                                attrs: {
                                  src: _vm._f("imgPath")(item.locationFlag),
                                  alt: "",
                                },
                              }),
                              _vm._v(" " + _vm._s(item.locationName) + " "),
                            ]),
                          ]
                        )
                      : _vm._e(),
                  ]
                }),
              ],
              2
            ),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.zoneList1.length > 6,
                    expression: "zoneList1.length > 6",
                  },
                ],
                staticClass: "more-btn",
                class: { expanded: _vm.zone1ShowMore },
                on: {
                  click: function ($event) {
                    _vm.zone1ShowMore = !_vm.zone1ShowMore
                  },
                },
              },
              [
                _vm._v(" " + _vm._s(_vm.$t("lang.newInvite.k024")) + " "),
                _c("img", {
                  attrs: { src: require("./images/arrow-r.png"), alt: "" },
                }),
              ]
            ),
          ],
          1
        ),
        _vm.baseInfo && _vm.baseInfo.actRewardIncome
          ? _c(
              "div",
              { staticClass: "rules-block", attrs: { id: "limitedBonus" } },
              [
                _c("p", { staticClass: "rules-title right-read" }, [
                  _vm._v(_vm._s(_vm.$t("lang.newInvite.k025"))),
                ]),
                _vm.baseInfo &&
                _vm.baseInfo.actLimitIncome &&
                _vm.baseInfo.actLimitDay &&
                _vm.baseInfo.actRewardIncome
                  ? _c("MyPLabel", {
                      staticClass: "rules-row",
                      attrs: {
                        str: _vm.$t("lang.newInvite.k026"),
                        numsOption: [
                          { value: _vm.baseInfo.actLimitIncome },
                          { value: _vm.baseInfo.actLimitDay },
                          {
                            value: _vm.baseInfo.actRewardIncome,
                            style: "color:#a338fc",
                          },
                        ],
                      },
                    })
                  : _vm._e(),
                _c("p", { staticClass: "rules-row right-read" }, [
                  _vm._v(_vm._s(_vm.$t("lang.newInvite.k022"))),
                ]),
                _c("p", { staticClass: "rules-row right-read" }, [
                  _vm._v(" " + _vm._s(_vm.$t("lang.newInvite.k027")) + " "),
                  _vm.baseInfo
                    ? _c("span", { staticStyle: { color: "#a338fc" } }, [
                        _vm._v(
                          _vm._s(
                            _vm.handleMoment(
                              _vm.baseInfo.actStartTime,
                              "DD/MM/YYYY"
                            )
                          ) +
                            " - " +
                            _vm._s(
                              _vm.handleMoment(
                                _vm.baseInfo.actEndTime,
                                "DD/MM/YYYY"
                              )
                            )
                        ),
                      ])
                    : _vm._e(),
                ]),
                _c("p", { staticClass: "rules-row right-read" }, [
                  _vm._v(_vm._s(_vm.$t("lang.newInvite.k028"))),
                ]),
                _c(
                  "div",
                  { staticClass: "zone-block" },
                  [
                    _vm._l(_vm.zoneList2, function (item, index) {
                      return [
                        (!_vm.zone2ShowMore && index < 6) || _vm.zone2ShowMore
                          ? _c(
                              "div",
                              {
                                key: item.locationCode,
                                staticClass: "zone-item right-align",
                              },
                              [
                                _c("div", [
                                  _c("img", {
                                    attrs: {
                                      src: _vm._f("imgPath")(item.locationFlag),
                                      alt: "",
                                    },
                                  }),
                                  _vm._v(" " + _vm._s(item.locationName) + " "),
                                ]),
                              ]
                            )
                          : _vm._e(),
                      ]
                    }),
                  ],
                  2
                ),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.zoneList2.length > 6,
                        expression: "zoneList2.length > 6",
                      },
                    ],
                    staticClass: "more-btn right-read",
                    class: { expanded: _vm.zone2ShowMore },
                    on: {
                      click: function ($event) {
                        _vm.zone2ShowMore = !_vm.zone2ShowMore
                      },
                    },
                  },
                  [
                    _vm._v(" " + _vm._s(_vm.$t("lang.newInvite.k024")) + " "),
                    _c("img", {
                      attrs: { src: require("./images/arrow-r.png"), alt: "" },
                    }),
                  ]
                ),
              ],
              1
            )
          : _vm._e(),
        _c(
          "div",
          { staticClass: "rules-block", attrs: { id: "commission" } },
          [
            _c("p", { staticClass: "rules-title right-read" }, [
              _vm._v(_vm._s(_vm.$t("lang.dl.commission"))),
            ]),
            _c("p", { staticClass: "rules-row right-read" }, [
              _vm._v(_vm._s(_vm.$t("lang.newInvite.k029"))),
            ]),
            _c("div", { staticClass: "deliver-line" }),
            _c("div", { staticClass: "list-fields right-read" }, [
              _c("div", { staticClass: "field field1" }, [
                _vm._v(_vm._s(_vm.$t("lang.inRule.th1"))),
              ]),
              _c("div", { staticClass: "field field2" }, [
                _vm._v(" " + _vm._s(_vm.$t("lang.inRule.th2")) + " "),
                _c("img", { attrs: { src: _vm.getMatchImg("beans") } }),
              ]),
              _c("div", { staticClass: "field field3" }, [
                _vm._v(_vm._s(_vm.$t("lang.newInvite.k030"))),
              ]),
            ]),
            _vm._l(_vm.CommissionNode, function (item) {
              return _c(
                "div",
                { key: item.level, staticClass: "list-fields right-read" },
                [
                  _c("div", { staticClass: "bd-field field1" }, [
                    _vm._v(_vm._s(item.level)),
                  ]),
                  _c("div", { staticClass: "bd-field field2" }, [
                    _vm._v(
                      _vm._s(_vm.thousandthDigit(item.minBeans)) +
                        "-" +
                        _vm._s(_vm.thousandthDigit(item.maxBeans))
                    ),
                  ]),
                  _c("div", { staticClass: "bd-field field3" }, [
                    _vm._v(_vm._s(item.levelRate) + "%"),
                  ]),
                ]
              )
            }),
          ],
          2
        ),
        _c("div", { staticClass: "rules-block" }, [
          _c("p", { staticClass: "rules-title right-read" }, [
            _vm._v(_vm._s(_vm.$t("lang.newInvite.k031"))),
          ]),
          _c("p", { staticClass: "rules-row right-read" }, [
            _vm._v(_vm._s(_vm.$t("lang.newInvite.k032"))),
          ]),
          _c("p", { staticClass: "rules-row right-read" }, [
            _vm._v(_vm._s(_vm.$t("lang.newInvite.k033"))),
          ]),
          _c("p", { staticClass: "rules-row right-read" }, [
            _vm._v(_vm._s(_vm.$t("lang.newInvite.k034"))),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }